export const SIDEBAR_WIDTH_OPEN = 28;
export const SIDEBAR_WIDTH_CLOSED = 7.5;

// Routes
export const DocsRoute = 'help-center/docs/';
